<script setup>
import { useClinical } from '@/composables/useClinical'
import { useApi } from '@/utils/api'

// Module 18 (§9.5) — "reuse Checklist fill + Assessment kepatuhan"
// (literal blueprint). Sama pola pages/mfk/checklist/index.vue (Module 16)
// untuk sisi checklist — TIDAK ada route fill baru di sini sama sekali
// (beda dengan MFK, modul ini tidak butuh auto-Task), submit langsung ke
// endpoint generik Module 12 lewat ChecklistFillForm.vue TANPA prop `mfk`.
// Skor kepatuhan PPI (Assessment) dikelola lewat halaman Assessment
// generik yang sudah ada (Module 13), difilter kategori "PPI" yang
// dipastikan ada oleh PpiComplianceService.
definePage({
  meta: {
    layout: 'default',
    action: 'ppi-audit',
    subject: 'Clinical',
  },
})

const { ppiCategories, fetchPpiCategories } = useClinical()

const templates = ref([])
const loadingTemplates = ref(false)
const selectedTemplateId = ref(null)

const load = async () => {
  loadingTemplates.value = true
  try {
    await fetchPpiCategories()

    const categoryIds = [ppiCategories.value.hand_hygiene_checklist_category_id, ppiCategories.value.apd_checklist_category_id]
      .filter(Boolean)

    const response = await useApi('/api/v1/checklist-templates', { query: { per_page: 100 } }).get()
    const data = response?.data ?? response
    const all = Array.isArray(data) ? data : (data?.data ?? [])

    templates.value = all.filter(t => categoryIds.includes(t.category?.id))
  } finally {
    loadingTemplates.value = false
  }
}

onMounted(load)

const templateOptions = computed(() => templates.value.map(t => ({ title: `${t.name} (${t.category?.name ?? '-'})`, value: t.id })))
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Audit PPI
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Hand Hygiene & APD via Checklist Engine, kepatuhan via Assessment Engine (§9.5)
    </p>

    <VRow>
      <VCol
        cols="12"
        md="7"
      >
        <VCard class="mb-4">
          <VCardTitle class="pa-6 pb-0">
            Checklist Hand Hygiene / APD
          </VCardTitle>
          <VCardText class="pa-6">
            <VSelect
              v-model="selectedTemplateId"
              :items="templateOptions"
              :loading="loadingTemplates"
              label="Pilih Checklist"
              clearable
            />
          </VCardText>
        </VCard>

        <ChecklistFillForm
          v-if="selectedTemplateId"
          :key="selectedTemplateId"
          :template-id="selectedTemplateId"
        />
      </VCol>

      <VCol
        cols="12"
        md="5"
      >
        <VCard>
          <VCardTitle class="pa-6 pb-0">
            Skor Kepatuhan PPI
          </VCardTitle>
          <VCardText class="pa-6">
            <p class="text-body-2 text-medium-emphasis">
              Penilaian kepatuhan PPI memakai Assessment Engine (kategori "Kepatuhan PPI"), dikelola
              lewat halaman Penilaian &gt; Template &amp; Skor.
            </p>
            <VBtn
              variant="tonal"
              :to="{ name: 'assessment-templates' }"
            >
              Buka Halaman Penilaian
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
